import {NgModule} from "@angular/core";
import {MomentPipe} from "./moment.pipe";
import {TimeDirective} from "./time.directive";
import {FieldFilterPipe} from './field-filter.pipe';
import {BodyService} from "./body.service";
import {NotificationService} from "./notification.service";
import {ToggleActiveDirective} from "./toggle-active.directive";
import {TaskCategoryService} from "../../+admin/+configuraciones/+tareas/+categorias/task.categorias.service";
import {UserFilter} from "./user-filter-pipe";
import {FilePipe} from "./filePipe";
import {AvatarUrlPipe} from "./avatar-image-pipe";
import {SMSortable} from "./SMSortable";
import { ReplacePipe } from './trim.pipe';


@NgModule({
    declarations: [ToggleActiveDirective, MomentPipe, TimeDirective, FieldFilterPipe, UserFilter, FilePipe, AvatarUrlPipe, SMSortable],
    exports: [ToggleActiveDirective, MomentPipe, TimeDirective, FieldFilterPipe, UserFilter, FilePipe, AvatarUrlPipe, SMSortable],
    providers: [BodyService, NotificationService]
})
export class UtilsModule {
    static forRoot() {
        return {
            ngModule: UtilsModule,
            providers: [BodyService, NotificationService, TaskCategoryService]
        }
    }
}
